/**
 * Enhanced Timeline Animation Script
 * Motorcycle-inspired animations with parallax and scroll effects
 */

(function() {
  'use strict';

  const CONFIG = {
    observerThreshold: 0.15,
    observerRootMargin: '0px 0px -80px 0px',
    parallaxSpeed: 0.3,
    wheelRotationSpeed: 20 
  };


  function initScrollObserver() {
    const observerOptions = {
      threshold: CONFIG.observerThreshold,
      rootMargin: CONFIG.observerRootMargin
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          entry.target.classList.add('aos-animate');

          const content = entry.target.querySelector('.timeline-content');
          if (content) {
            content.classList.add('aos-animate');
          }

          const badge = entry.target.querySelector('.year-badge');
          if (badge) {
            badge.classList.add('active');
          }

          const speedLines = entry.target.querySelector('.speed-lines');
          if (speedLines) {
            speedLines.classList.add('active');
          }

        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('[data-aos]');
    elements.forEach(el => {
      observer.observe(el);
    });
  }

  function animateTimelineFill() {
    return;
  }

  function updateTimelineFill(timelineSection) {
    // Function disabled
    return;
  }

  function initParallaxEffect() {
    // Parallax disabled as per client request
    return;
  }

  function applyParallax() {
    // Function disabled
    return;
  }

  /**
   * Enhanced hover effects for timeline blocks
   */
  function initHoverEffects() {
    const timelineBlocks = document.querySelectorAll('.timeline-block');
    
    timelineBlocks.forEach(block => {
      const imageContainer = block.querySelector('.image-container');
      
      if (imageContainer) {
        block.addEventListener('mouseenter', function() {
          this.style.zIndex = '10'; // Changed from 100 to 10
        });
        
        block.addEventListener('mouseleave', function() {
          this.style.zIndex = '1'; // Changed from 2 to 1
        });
      }
    });
  }

  /**
   * Add stagger delay to child elements
   */
  function addStaggerDelay() {
    const timelineBlocks = document.querySelectorAll('.timeline-block');
    
    timelineBlocks.forEach((block, index) => {
      const imageContainer = block.querySelector('.image-container');
      const textContent = block.querySelector('.text-content');
      
      if (imageContainer) {
        imageContainer.style.transitionDelay = `${0.1 * index}s`;
      }
      
      if (textContent) {
        textContent.style.transitionDelay = `${0.2 + (0.1 * index)}s`;
      }
    });
  }

  /**
   * Smooth scroll reveal with threshold check
   */
  function checkScrollPosition() {
    const timelineBlocks = document.querySelectorAll('.timeline-block');
    
    timelineBlocks.forEach(block => {
      const rect = block.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight * 0.85;
      
      if (isVisible && !block.classList.contains('aos-animate')) {
        block.classList.add('aos-animate');
        
        const content = block.querySelector('.timeline-content');
        if (content) {
          content.classList.add('aos-animate');
        }
      }
    });
  }

  /**
   * Add year badge rotation based on scroll
   */
  function initBadgeScrollRotation() {
    let ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const badges = document.querySelectorAll('.year-badge');
          const scrolled = window.pageYOffset;
          
          badges.forEach((badge, index) => {
            const blockTop = badge.closest('.timeline-block').offsetTop;
            const rotation = (scrolled - blockTop) * 0.1;
            
            if (badge.closest('.timeline-block').classList.contains('aos-animate')) {
              badge.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
            }
          });
          
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /**
   * Initialize smooth entrance for images
   */
  function initImageEntrance() {
    const images = document.querySelectorAll('.main-image');
    
    images.forEach(img => {
      // Ensure image is loaded before showing
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.addEventListener('load', function() {
          this.style.opacity = '1';
        });
      }
    });
  }

  /**
   * Add custom cursor effect on hover (optional)
   */
  function initCustomCursor() {
    const imageContainers = document.querySelectorAll('.image-container');
    
    imageContainers.forEach(container => {
      container.style.cursor = 'pointer';
      
      container.addEventListener('mouseenter', function() {
        this.style.transform = 'scale(1.02)';
      });
      
      container.addEventListener('mouseleave', function() {
        this.style.transform = 'scale(1)';
      });
    });
  }

  /**
   * Performance optimization: Reduce animations on mobile
   */
  function optimizeForMobile() {
    const isMobile = window.innerWidth <= 968;
    
    if (isMobile) {
    }
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function handleResize() {
    const debouncedResize = debounce(function() {
      optimizeForMobile();
      checkScrollPosition();
    }, 250);
    
    window.addEventListener('resize', debouncedResize);
  }

  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeTimeline);
    } else {
      initializeTimeline();
    }
  }

  function initializeTimeline() {
    console.log('🏍️ Initializing Enhanced Timeline Animations...');
    
    initScrollObserver();
    initHoverEffects();
    initImageEntrance();
    initBadgeScrollRotation();

    optimizeForMobile();
    handleResize();
    checkScrollPosition();
    
    console.log('✅ Timeline animations initialized successfully!');
  }


  window.TimelineEnhanced = {
    init: init,
    refresh: checkScrollPosition
  };

  // Auto-initialize
  init();

})();